@let minimizedView = isMinimizedView();
@let rowView = isRowView();
@let short = shortView();
@let showCustomSeparator = showSeparator();

<div
  class="w-full h-full flex flex-col bg-gradient-to-l from-(--p-other-blue-100) to-(--p-other-blue-200)"
  [ngClass]="{
    'px-[1.125rem]': !minimizedView,
    'px-[1rem]': minimizedView,
    'py-[1.25rem]': !minimizedView && !rowView,
    'pt-[0.6875rem] pb-[0.875rem]': !minimizedView && rowView,
    'pt-[1.5rem] pb-[1.625rem]': minimizedView && !rowView,
    'pt-[0.4375rem] pb-[0.375rem]': minimizedView && rowView,
    'rounded-[0.5rem]': showRounded(),
  }">
  <div
    class="w-full grow-1 flex flex-col gap-[1.5rem] sm:pb-(--date-selection-reserved-height-for-sm-and-md) lg:pb-0"
    [ngClass]="{
    '!flex-row !items-center': rowView,
    'gap-0': showCustomSeparator,
    'gap-[1.5rem]': !showCustomSeparator,
    }">
    @let data = correlation();
  
    @if (data) {
      <gc-ld-correlation-type-icon-with-quality
        [correlation]="data"
        [small]="!screenResolutionService.isScreenMdUp()"
        [ngClass]="{
          'grow-1': rowView && minimizedView && short,
        }">
      </gc-ld-correlation-type-icon-with-quality>
  
       @if (showCustomSeparator) {
        <div class="flex flex-col grow-100 justify-center max-h-[3rem] min-h-[0.3125rem]">
          <div class="bg-(--p-other-opacity-white-15) w-full h-[1px]"></div>
        </div>
       }

      <gc-fp-correlation-graph-info-leak class="grow-1" [isMinimizedView]="minimizedView && rowView" [shortView]="short"></gc-fp-correlation-graph-info-leak>
    }
  </div>
</div>
